import React from "react";
import { Helmet } from "react-helmet";

const MathBalloonPopMeta = () => {
  return (
    <div>
      <Helmet>
        <title>MathSpeedUp - Math Balloon Pop</title>
        <meta charSet="UTF-8" />
        <meta name="title" content="MathSpeedUp - Math Balloon Pop Game" />
        <meta
          name="description"
          content="Play the fun and interactive Math Balloon Pop game on MathSpeedUp! Sharpen your math skills by solving addition problems and popping the correct balloons. Ideal for kids and math learners."
        />
        <meta
          name="keywords"
          content="Math Game, Balloon Pop, Math Balloon Pop, Educational Game, Kids Math Game, MathSpeedUp, Addition Practice"
        />
        <meta
          property="article:published_time"
          content="2024-04-15T00:00:00+00:00"
        />
      </Helmet>
    </div>
  );
};

export default MathBalloonPopMeta;
